import React from 'react'
import { FaUpload } from 'react-icons/fa6'

import { MessageActionsProps } from './'
import MenuItem from '~components/shared/menu/menu-item'
import { useWritebackMessages } from '~utils/hooks/use-writeback-messages'
import { getWritebackEnabled } from '~utils/helpers'

export default function WritebackMessageAction({
    message,
    chat,
}: MessageActionsProps) {
    const [writebackMessages] = useWritebackMessages()

    const writebackIsEnabled = getWritebackEnabled(chat.clinic.pms)

    if (!writebackIsEnabled) return null

    return (
        <MenuItem
            icon={FaUpload}
            onClick={() => {
                writebackMessages(chat.id, [message])
            }}
        >
            Save Message to PIMS
        </MenuItem>
    )
}
